export default __webpack_public_path__ + "static/media/illuminate3.7d9bde15.png";